const Contact = () => {
  return (
    <div>
      Contact <a href="https://github.com/Apostolos172/">Apostolos172</a>
    </div>
  );
};

export default Contact;
